import React from 'react';
import { useExternalCompany } from 'src/hooks/use-external-company';
import useMember from 'src/hooks/use-member';
import CompanyInformationAboutTab from '../../components/company/company-tabs/CompanyInformationAboutTab';
import CompanyInformationEconomyTab from '../../components/company/company-tabs/CompanyInformationEconomyTab';
import CompanyInformationRegistreTab from '../../components/company/company-tabs/CompanyInformationRegistreTab';
import { useTranslation } from 'react-i18next';
import { LoadingPage } from 'src/components/LoadingPage/LoadingPage';
import CompanyInformationApplicationsTab from '../../components/company/company-tabs/CompanyInformationApplicationsTab';
import { Details } from '@innovationnorway/cl-react';
import '../../../styles/CompanyInformationDetails.scss';
import { useAuth } from 'src/features/authorization';

type Props = {
  organizationNumber: string;
  clusterMemberId: string;
  hideNaceWarning?: boolean;
};

const sections = ['about', 'register', 'economy', 'applications'] as const;

const CompanyInformationDetails: React.FC<Props> = ({
  clusterMemberId,
  organizationNumber,
  hideNaceWarning,
}) => {
  const { t: tSiva } = useTranslation('siva');

  const { data: externalCompany, isInitialLoading: externalCompanyLoading } =
    useExternalCompany(organizationNumber);
  const { member, isInitialLoading: memberLoading } = useMember(clusterMemberId);
  const { isLoading: authLoading } = useAuth();

  if (externalCompanyLoading || memberLoading || authLoading) return <LoadingPage />;

  if (!externalCompany) return <div>{tSiva('companyTabs.error.loadingFailed')}</div>;

  return (
    <div className="company-information-details">
      {sections.map((section) => (
        <Details key={'section__' + section} data-size="md">
          <Details.Summary>{tSiva(`companyTabs.tabs.${section}`)}</Details.Summary>
          <Details.Content>
            {section === 'about' && (
              <CompanyInformationAboutTab
                company={externalCompany}
                member={member}
                hideNaceWarning={hideNaceWarning}
              />
            )}
            {section === 'register' && <CompanyInformationRegistreTab company={externalCompany} />}
            {section === 'economy' && <CompanyInformationEconomyTab company={externalCompany} />}
            {section === 'applications' && <CompanyInformationApplicationsTab />}
          </Details.Content>
        </Details>
      ))}
    </div>
  );
};

export default CompanyInformationDetails;
